import { Dialog, DialogTitle, IconButton } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { Form, Formik, FormikHelpers } from "formik";
import React from "react";
import { FormattedMessage } from "react-intl";
import styled from "styled-components";
import { TContactInfo, TContactRelationshipOp } from "../../types";
import ContactRelationModalForm, {
  TContactRelationModalForm,
} from "./ContactRelationModalForm";
import useContactRelationModalFormValidation from "./useContactRelationModalFormValidation";
import uuidv4 from "uuid/v4";

const StyledDialog = styled(Dialog)`
  .MuiDialog-paper {
    min-width: 40rem;
  }
`;

const StyledCloseButton = styled(IconButton)`
  position: absolute;
  top: 0.75rem;
  right: 0.75rem;
`;

interface IContactRelationModalProps {
  open: boolean;
  onCancel: () => void;
  kinshipOptions: { value: string; label: string }[];
  onContactSelect: (contact: TContactInfo) => void;
  contact?: TContactInfo;
}

const ContactRelationModal = (props: IContactRelationModalProps) => {
  const { open, onCancel, kinshipOptions, onContactSelect, contact } = props;
  const validationSchema = useContactRelationModalFormValidation();

  const initialValues: TContactRelationModalForm = {
    id: contact?.id ?? uuidv4(),
    contact_id: contact?.contact_id ?? "",
    apiOp: contact?.op ?? null,
    op:
      contact?.op === "existing_relation" ||
      contact?.op === "modify_existing_relation" ||
      contact?.op === "new_relation_existing_contact"
        ? "existing"
        : "new",
    First_Name: contact?.First_Name ?? "",
    Last_Name: contact?.Last_Name ?? "",
    Phone: contact?.Phone ?? "",
    phone_used_by: null,
    Email: contact?.Email ?? "",
    email_used_by: null,
    Parentesco:
      kinshipOptions.find((option) => option.value === contact?.Parentesco) ??
      null,
  };

  const handleFormSubmit = (
    values: TContactRelationModalForm,
    actions: FormikHelpers<TContactRelationModalForm>
  ) => {
    let newOp: TContactRelationshipOp =
      values.op === "new"
        ? "new_relation_new_contact"
        : "new_relation_existing_contact";
    if (values.apiOp) {
      if (values.apiOp === "existing_relation") {
        newOp = "modify_existing_relation";
      }
      if (
        values.apiOp === "modify_existing_relation" ||
        values.apiOp === "new_relation_existing_contact" ||
        values.apiOp === "new_relation_new_contact"
      ) {
        newOp = values.apiOp;
      }
    }
    onContactSelect({
      id: values.id,
      contact_id: values.contact_id,
      op: newOp,
      First_Name: values.First_Name,
      Last_Name: values.Last_Name,
      Phone: values.Phone,
      Email: values.Email,
      Parentesco: values.Parentesco?.value,
    });
  };

  return (
    <StyledDialog open={open} onClose={onCancel}>
      <StyledCloseButton onClick={onCancel}>
        <CloseIcon />
      </StyledCloseButton>
      <DialogTitle>
        <FormattedMessage
          id="ContactRelationModal.Title"
          defaultMessage="Añadir relación con contacto"
        />
      </DialogTitle>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleFormSubmit}
      >
        <Form>
          <ContactRelationModalForm
            onCancel={onCancel}
            kinshipOptions={kinshipOptions}
          />
        </Form>
      </Formik>
    </StyledDialog>
  );
};

export default ContactRelationModal;
